import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClientXsrfModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';

import { PrimeNGModule } from './shared/primeng.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Application Components
import { AppCodeModule } from './app.code.component';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppConfigComponent } from './app.config.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppTimelineDemoComponent } from './pages/app.timelinedemo.component';
import { AppInvoiceComponent } from './pages/app.invoice.component';
import { AppHelpComponent } from './pages/app.help.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppNotfoundCoComponent } from './pages/app.notfoundco.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';

import { DisplayComponent } from './utilities/display.component';
import { ElevationComponent } from './utilities/elevation.component';
import { FlexboxComponent } from './utilities/flexbox.component';
import { GridComponent } from './utilities/grid.component';
import { IconsComponent } from './utilities/icons.component';
import { WidgetsComponent } from './utilities/widgets.component';
import { SpacingComponent } from './utilities/spacing.component';
import { TypographyComponent } from './utilities/typography.component';
import { TextComponent } from './utilities/text.component';

import { BreadcrumbService } from './app.breadcrumb.service';
import { MenuService } from './app.menu.service';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared';

import { RequestCache, RequestCacheWithMap } from './request-cache.service';
import { AppResolver } from './app-resolver.service';
import { HttpErrorHandler } from './http-error-handler.service';
import { httpInterceptorProviders } from './http-interceptors/index';

import { AuthModule } from './auth/auth.module';
import { RouteReuseStrategy } from '@angular/router';

//Mensajes primeNG
import { MessageService } from 'primeng/api';

import { FAZILService, User, UserService } from './core';

import { MarkAsteriskDirectiveModule } from './directives/mark-asterisk.directive';
import { CedulaValidator } from './shared/validators';
import { InicioModule } from './inicio/inicio.module';

import { AdministracionModule } from './administracion/administracion.module';
import { AuditoriaModule } from './auditoria/auditoria.module';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { FacturasModule } from './facturas/facturas.module';
import { AppLandingComponent } from './pages/app.landing.component';

import { BlockViewer } from './blocks/blockviewer/blockviewer.component';

import { AppResetpasswordComponent } from './pages/app.resetpassword.component';
import { AppResetpasswordConfigComponent } from './pages/app.resetpasswordconfig.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatIconModule} from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppInfoComponent } from './app.info.component';
import { DialogService } from 'primeng/dynamicdialog';
import { UIService } from './core/services/ui.service';
import { AppAdminComponent } from './app.admin.component';
import { RegistroModule } from './registro/registro.module';

registerLocaleData(localeEs, 'es');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'es_EC'
        }),
        ReactiveFormsModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'My-Xsrf-Cookie',
            headerName: 'My-Xsrf-Header'
        }),
        AppRoutingModule,
        BrowserAnimationsModule,
        PrimeNGModule,
        AppCodeModule,
        CoreModule,
        SharedModule,
        AuthModule,
        InicioModule,
        AdministracionModule,
        FacturasModule,
        MarkAsteriskDirectiveModule,
        AuditoriaModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatFormFieldModule
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppAdminComponent,
        AppInfoComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppConfigComponent,
        AppBreadcrumbComponent,
        DisplayComponent,
        ElevationComponent,
        FlexboxComponent,
        GridComponent,
        IconsComponent,
        WidgetsComponent,
        SpacingComponent,
        TypographyComponent,
        TextComponent,
        AppLoginComponent,
        AppInvoiceComponent,
        AppHelpComponent,
        AppNotfoundComponent,
        AppNotfoundCoComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        AppTimelineDemoComponent,
        AppResetpasswordComponent,
        AppResetpasswordConfigComponent,
        CedulaValidator,
        AppLandingComponent,
        BlockViewer,
    ],
    providers: [
        HttpErrorHandler,
        { provide: RequestCache, useClass: RequestCacheWithMap },
        MenuService,
        BreadcrumbService,
        httpInterceptorProviders,
        AppResolver,
        MessageService,
        { provide: LOCALE_ID, useValue: 'es' },
        AppMainComponent,
        DialogService,
        FAZILService,
        UIService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }